export class Constants {
  public static readonly wowTokenId = 122284;
}
